import { render, staticRenderFns } from "./HatcheryMetrics.vue?vue&type=template&id=4d87a32d&scoped=true&"
import script from "./HatcheryMetrics.vue?vue&type=script&lang=js&"
export * from "./HatcheryMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d87a32d",
  null
  
)

export default component.exports